module.exports = __webpack_public_path__ + "static/media/sanchu_icon.ae0d84a9.jpg";